module.exports = __webpack_public_path__ + "img/6.216cc5e5.jpg";